export default function Err404() {


    return (<div>La page demandée est introuvble.</div>)
}